import { Skeleton } from 'antd';

import styles from './card-grid-skeleton.module.scss';

export type CardGridSkeletonProps = {
  count?: number;
};

export function CardGridSkeleton({ count = 9 }: CardGridSkeletonProps) {
  return (
    <div className={styles.grid} aria-busy="true" aria-label="Loading">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className={styles.card} data-testid="card-skeleton">
          <Skeleton.Input active block size="small" />
        </div>
      ))}
    </div>
  );
}
